













































import Vue from "vue";
import NotificationBtn from "@/components/NotificationBtn.vue";

export default Vue.extend({
  components: { NotificationBtn },

  name: "AppBar",

  data() {
    return {
      menuItems: ["Dashboard", "Content", "Settings", "Support"],
      activeMenuItem: "Dashboard",
    };
  },

  methods: {
    onAddWebsiteClick() {
      this.$emit("add-website");
    },
  },
});
